<template>
<span class="offerpdp">

	<div class="mt-2" v-if="offertweb==1">
		
		Available offers 
			<p class="offertitle" ><i class="fa fa-tag tageOffer" aria-hidden="true"></i> +20% Cashback <span class="tncc"><b-link id="popover-target-3"> T&C </b-link></span></p>
				<b-popover target="popover-target-3" triggers="hover" placement="bottom" class="offerPop">
							<!--<template #title>Popover Title</template> -->
							 <b-container class="text-left">
								<ul class="p-0">
									<li class="m-0">i) The Offer is applicable only on prepaid orders.</li>
									<li class="m-0">ii) The Offer is applicable for a successful transaction.</li>
								</ul>
									
							</b-container>
						  </b-popover>

		
	 </div> 
	 <div class="mt-2" v-if="offertweb==0">
		Available offers 
			<p class="offertitle" ><i class="fa fa-tag tageOffer" aria-hidden="true"></i> +20% Cashback <span class="tncc"><b-link id="popover-target-4"> T&C </b-link></span></p>
				<b-popover target="popover-target-4" triggers="hover" placement="bottom" class="offerPop">
							<!--<template #title>Popover Title</template> -->
							 <b-container class="text-left">
								<ul class="p-0">
									<li class="m-0">i) The Offer is applicable only on prepaid orders.</li>
									<li class="m-0">ii) The Offer is applicable for a successful transaction.</li>
								</ul>
									
							</b-container>
						  </b-popover>

		
	 </div> 
  
  </span>
</template>

<script>
export default {
  name: "ProductOffer",
  props: {
    offertweb:Number,
    product:Object
  },
  data(){
    return {
      product_qty:1,
      special_price:100,
      price:200
    }
  }
};
</script>
<style  scoped lang="scss">
$whiteColor: #ffffff;
$blackColor: #000000;
$themeColor2: #8507d6;
$themeColor3: #b24bf1;
$redColor: #ec3f79;
$redpColor: #ea0d14;
$saleColor: #ec3f79;
$beatSellerColor:#82ca9c;
$offerColor:#fea838;
$featuredColor:#fea838;
$newProductColor:#82ca9c;

.offerpdp{
	
	/*font-size: 14px;
	padding:2px;*/
	.offertitle{
		.tageOffer{
			color:$themeColor3;
		}.tncc{
			color:$themeColor3;
			a{
			color:$themeColor3;
			}
		}
	}
	
	
	  
}
.popover{
		max-width:30% !important;
		
	}
	
	@media only screen and (max-width:640px) {
		.popover{
		max-width:90% !important;
		
	}
	
	}

</style>